module.exports = __webpack_public_path__ + "static/july-1-2e776c03c2395867ff64dc8aa5d9e72d.png";